import React from 'react'
import * as T from '../../../components/Table'
import { Producao360Item } from './Producao360Item'
import { useProducao360Context } from '../../../contexts/Producao360Provider'

export const Producao360List = () => {
  const { query } = useProducao360Context()
  const { data, isLoading, isRefetching } = query

  console.log(data)

  if (!Array.isArray(data?.lista)) {
    return (
      <T.Tr>
        <T.Td colSpan="9">Nenhum dado encontrado</T.Td>
      </T.Tr>
    )
  }

  return isLoading ? (
    <T.Tr>
      <T.TdSkeleton colSpan="9" />
    </T.Tr>
  ) : (
    data?.lista?.map((item) => <Producao360Item key={item.id_solicitacao} item={item} />)
  )
}
